import ProductHelpers, {activatePromoAnimationMessage} from './base';
import {newModal, newModalFromString} from '../components/modal';
import {initSlotCarousel, initProductTile} from '../productTileComponent/productTile';
import {checkCarouselLength} from '../customCarousel';

function isPortionOfElementInContainer(el, container) {
    const rect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    const windowHeight =
        (window.innerHeight || document.documentElement.clientHeight) - containerRect.top;
    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = rect.top <= windowHeight && rect.top + 0.66 * rect.height >= 0;
    return vertInView;
}

function computeCurrentlyVisibleImage() {}

const handleDetailsTabs = (clickedTab) => {
    $('.js-detailsPopup-tabContent, .js-detailsPopup-tabLink').removeClass('cc-currentTab');
    $(
        '.js-detailsPopup-tabContent#' +
            clickedTab +
            ', .js-detailsPopup-tabLink[data-tab=' +
            clickedTab +
            ']'
    ).addClass('cc-currentTab');
};

const openQuickView = (url, modalClass) => {
    const modal = newModal(false, ['quickview-modal']);
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: (html) => {
            modal.setContent(html.renderedTemplate);
            if (Foundation.MediaQuery.atLeast('large')) {
                $('.product-quickview .carousel-inner').slick({
                    arrows: true,
                    dots: false,
                    slidesToShow: 1,
                });
            }

            // QuickView
            $('.product-quickview .js-carousel-select-color-quickview')
                .slick({
                    slidesToShow: 6,
                    slidesToScroll: 2,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 10,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 2,
                            },
                        },
                    ],
                })
                .slick('setPosition');

            $('body').trigger('product:crossSellLoaded', true);

            $('.product-quickview .js-carousel-select-size')
                .slick({
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    infinite: false,
                })
                .slick('setPosition');

            if (modalClass) {
                $(modal.modalBox).find('.product-quickview').addClass(modalClass);
            }

            modal.open();
            $(modal.modalBox)
                .find('.close-custom')
                .on('click', function (e) {
                    modal.close();
                    modal.destroy();
                });
            $('body').on('product:afterAddToCart', function (data) {
                modal.close();
                modal.destroy();
            });
        },
        error: (err) => {
            console.log('Error:', err);
        },
    });
};

const setMinHeightPromoPanel = (container) => {
    var _array = [];
    $(container)
        .find('div.promo-message.js-promo-container')
        .each(function () {
            _array.push($(this).innerHeight());
        });
    var maxHeight = Math.max.apply(Math, _array);
    $(container)
        .find('div.promo-message.js-promo-container')
        .each(function () {
            $(this).css('min-height', maxHeight);
        });

    var _array2 = [];
    $(container)
        .find('.product-tile__name')
        .each(function () {
            _array2.push($(this).innerHeight());
        });
    var maxHeightTitle = Math.max.apply(Math, _array2);
    $(container)
        .find('.product-tile__name')
        .each(function () {
            $(this).css('min-height', maxHeightTitle);
        });
};

const getProductVariationGroup = (product, type) => {
    if (typeof product === 'string') {
        return product.trim();
    }

    if (type === 'size') {
        return product.id;
    }

    // size and color have already been selected. In this case, the variation
    // group is built with the style of the product, 'color' and the selected
    // color variation
    let pid = '';
    if (product.productType === 'variant') {
        pid = product.id.split(' ')[0].trim();
    } else if (product.productType === 'variationGroup') {
        // in this case the user only chose the color, and not the size
        pid = product.id.split('_')[0].trim();
    }
    let selectedVariation;

    for (let k in product.variationAttributes) {
        const variationAttribute = product.variationAttributes[k];
        if (variationAttribute.attributeId === 'color') {
            for (let j in variationAttribute.values) {
                if (variationAttribute.values[j].selected === true) {
                    selectedVariation = variationAttribute.values[j].value;
                    break;
                }
            }
        }
        // If a size is selected and selectable, retrieve its recommendation instead of variant color's one
        if (variationAttribute.attributeId === 'size') {
            for (let j in variationAttribute.values) {
                if (
                    variationAttribute.values[j].selected === true &&
                    variationAttribute.values[j].selectable === true
                ) {
                    return product.id;
                }
            }
        }
    }

    return pid + '_color_' + selectedVariation;
};

const crossSellItems = (product, type) => {
    if (!document.getElementById('crossSellItemsBaseUrl')) {
        return;
    }
    const pid = getProductVariationGroup(product, type);
    let requestUrl = document.getElementById('crossSellItemsBaseUrl').value;
    let isSizeChange = type === 'size';
    const promotionId = $('.marketing-messages.pdp .marketing-budge').data('promotion-id');
    $.ajax({
        url: requestUrl,
        method: 'GET',
        data: {
            pid: pid,
            promotionId: promotionId,
        },
        success: (data) => {
            const $result = $(data);

            const $completePromoData = $result.find('#completePromoProducts');
            const $completePromoSection = $('.js-completePromo');
            const $completePromoProducts = $completePromoSection.find('.crossSellContainer');
            $completePromoProducts.empty();
            if ($completePromoData.length) {
                $completePromoProducts.empty().append($completePromoData.html());
                $completePromoSection
                    .find('.promo-budge-container')
                    .empty()
                    .append($('.marketing-messages.pdp .marketing-budge:first').text().trim());
                const $completePromoContainer = $result.find('#completePromoContainer');
                if ($completePromoContainer.length) {
                    $completePromoSection
                        .find('.js-completePromo-grid-info-description')
                        .removeClass('hidden')
                        .html($completePromoContainer.find('.js-promoDetails-description').html());
                    $completePromoSection
                        .find('.js-completePromo-grid-info-budge')
                        .removeClass('hidden')
                        .html($completePromoContainer.find('.js-promoDetails-calloutMsg').html());
                } else {
                    $completePromoSection.find('.promo-more-info').addClass('hidden');
                }
                $completePromoSection.removeClass('hidden');
                checkCarouselLength('.js-promoCarousel');
            } else {
                $completePromoSection.addClass('hidden');
            }

            const $completeLookData = $result.find('#completeLookProducts');
            const $completeLookSection = $('.js-completeLook');
            const $completeLookProducts = $completeLookSection.find('.crossSellContainer');
            $completeLookProducts.empty();
            if ($completeLookData.length) {
                $completeLookProducts.empty().append($completeLookData.html());
                $completeLookSection.removeClass('hidden');
                checkCarouselLength('.js-lookCarousel');
            } else {
                $completeLookSection.addClass('hidden');
            }

            if ($completePromoData.length && $completeLookData.length) {
                $('.recommended-products-pdp').addClass('hidden');
            } else {
                $('.recommended-products-pdp').removeClass('hidden');
            }

            $('body').on(
                'click',
                '.js-completePromo .crossSellContainer .js-pdp-link, .js-completeLook .crossSellContainer .js-pdp-link',
                (evt) => {
                    // Open QuickView only not mobile

                    evt.preventDefault();
                    const url = evt.currentTarget.dataset.quickview;
                    // Completa il tuo look
                    let modalClass;
                    if ($(evt.currentTarget).closest('.js-completeLook').length) {
                        modalClass = 'complete-look-quick-view';
                    }
                    openQuickView(url, modalClass);

                    /*
                else {
                    if ($(evt.currentTarget).closest('.product').find('.add-to-cart-quick-add').attr('data-size-available') !== 'true') {
                        evt.preventDefault();
                        evt.stopPropagation();
                        $(evt.currentTarget).closest('.product').find('.product-detail-quick-add').find('.js-panel-opener-size-quick-add').trigger('click', { mustAdd: true });
                    }
                }
                */
                }
            );

            $('.js-completeLook .product-detail-quick-add .add-to-cart-quick-add').on(
                'click',
                (e) => {
                    if (
                        $(e.currentTarget).attr('data-size-available') !== 'true' &&
                        Foundation.MediaQuery.is('large')
                    ) {
                        e.preventDefault();
                        e.stopPropagation();
                        $(e.currentTarget)
                            .closest('.product-detail-quick-add')
                            .find('.js-panel-opener-size-quick-add')
                            .trigger('click', {mustAdd: true});
                    } else if (!Foundation.MediaQuery.is('large')) {
                        e.preventDefault();
                        e.stopPropagation();
                        openQuickView(
                            $(e.currentTarget)
                                .closest('.product')
                                .find('.js-pdp-link')
                                .data('quickview'),
                            'complete-look-quick-view'
                        );
                    }
                }
            );

            setTimeout(function () {
                setMinHeightPromoPanel('.js-completePromo');
                setMinHeightPromoPanel('.js-completeLook');
            }, 300);
            $('body').trigger('product:crossSellLoaded', isSizeChange);
        },
        error: () => {
            $.spinner().stop();
            $('body').trigger('product:crossSellError');
        },
    });
};

const openCurtain = () => {
    $('.overlay-pdp-mobile').show();
    $('#esw-fab').addClass('ui-eswback');
};

const closeCurtain = () => {
    $('.overlay-pdp-mobile').hide();
    $('#esw-fab').removeClass('ui-eswback');
};

function closeAllOpenMenus() {
    if (Foundation.MediaQuery.atLeast('medium')) {
        return;
    }
    // Close open menus
    $('.js-select-size-for-mobile').addClass('hidden').removeClass('open');
    $('.js-select-color-for-mobile').addClass('hidden').removeClass('open');
    $('.js-panel-opener-color').removeClass('on');
    $('.js-panel-opener-size').removeClass('on');
    closeCurtain();
}

function removeNulls(el) {
    var price = el.find('.analytics').data('price');
    if (
        !price ||
        price == null ||
        price === 'null' ||
        price === '' ||
        price === 0 ||
        price == '0.00'
    ) {
        el.css('display', 'none');
        return true;
    }
    return false;
}

const updatePrimaryImagesSlide = () => {
    let height = $('.primary-images .slick-active').outerHeight();
    $('.primary-images .slick-list').outerHeight(height);
    $('#miniatureVerticalImg .slide').removeClass('active');
    let index = $('.primary-images .slick-active').data('index');
    $(`#miniatureVerticalImg .slide[data-index="${index}"]`).addClass('active');
};

const enableImageSlideHeightObservers = () => {
    let imgNode = $('.primary-images .slick-list .carousel-item:first-child img');
    if (imgNode.length) {
        let config = {attributes: true, childList: true, subtree: true};
        let callback = function (mutationsList, observer) {
            for (let index = 0; index < mutationsList.length; index++) {
                let mutation = mutationsList[index];
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    mutation.target.classList.contains('lazyloaded')
                ) {
                    updatePrimaryImagesSlide();
                }
            }
        };
        let observer = new MutationObserver(callback);
        observer.observe(imgNode[0], config);
    }
    let slickNode = $('.primary-images .slick-track');
    if (slickNode.length) {
        let config = {attributes: true, childList: true, subtree: true};
        let callback = function (mutationsList, observer) {
            for (let index = 0; index < mutationsList.length; index++) {
                let mutation = mutationsList[index];
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    updatePrimaryImagesSlide();
                }
            }
        };
        let observer = new MutationObserver(callback);
        observer.observe(slickNode[0], config);
    }
};

const destroyPrimaryImagesSlider = () => {
    if (
        Foundation.MediaQuery.is('medium') &&
        $('.product-detail-keeper').length &&
        !$('.product-quickview.product-detail').length &&
        $('.primary-images').hasClass('slick-initialized')
    ) {
        $('.primary-images')
            .off('afterChange', updatePrimaryImagesSlide)
            .off('init', enableImageSlideHeightObservers)
            .slick('unslick');
    }
};

const initializePrimaryImagesSlider = () => {
    if (
        $('.product-detail-keeper').length &&
        !$('.product-quickview.product-detail').length &&
        !$('.primary-images').hasClass('slick-initialized')
    ) {
        $('.primary-images').slick({
            arrows: false,
            dots: true,
            infinite: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1.4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 765,
                    settings: {
                        slidesToShow: 1.07,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    const disableAutoScroll = () => {
        $('.primary-images').slick('slickPause');
        $('body').off('touchstart', this);
    };
    $('body').on('touchstart', disableAutoScroll);
};

const updatePrimaryImagesSlider = (primaryImages) => {
    if (
        Foundation.MediaQuery.is('medium') &&
        $('.product-detail-keeper').length &&
        !$('.product-quickview.product-detail').length
    ) {
        initializePrimaryImagesSlider();
        let carouselItems = $('.primary-images .carousel-item');
        if (carouselItems.length) {
            for (let i = primaryImages.length; i < carouselItems.length; i++) {
                $('.primary-images').slick('slickRemove', primaryImages.length);
            }
        }
    }
};

class Product {
    run() {
        ProductHelpers.run();
        // this.updateAttributesAndDetails();
        this.showSpinner();
        this.updateAttribute();
        this.updateAddToCart();
        this.updateAvailability();
        // this.sizeChart();
        this.getCrossSellItems();
        this.afterUpdateImages();
        this.recentlyViewedItems();
        this.buyNowQuichview();
        this.suggedtedProductsPDP();
        this.observeCurtainTap();
        this.removeNullCrossSell();
        this.pdpCrossSell();
        this.handleAccordionsInPDP();
        this.changeAddToBagButton();
        initializePrimaryImagesSlider();
    }

    changeAddToBagButton() {
        $('body').on('click', '.js-add-to-cart', function (e) {
            var button = $(this);

            $('body').on('product:afterAddToCart', function () {
                button.addClass('clicked');
                setTimeout(() => {
                    button.removeClass('clicked');
                }, 3000);
            });
        });
    }

    removeNullCrossSell() {
        $('body').on('product:crossSellLoaded', function (e) {
            let $container = $('.js-completePromo .crossSellContainer');
            let index = 0;
            let items = $container.find('.js-cross-product').length;
            $container.find('.js-cross-product').each(function () {
                if (removeNulls($(this))) {
                    index++;
                }
            });
            if (index == items) {
                $('.js-completePromo').addClass('hidden');
            }

            $container = $('.js-completeLook .crossSellContainer');
            index = 0;
            items = $container.find('.js-cross-product').length;
            $container.find('.js-cross-product').each(function () {
                if (removeNulls($(this))) {
                    index++;
                }
            });
            if (index == items) {
                $('.js-completeLook').addClass('hidden');
            }
        });
        $('body').on(
            'listing:einsteinloadedSuggestedProducts listing:einsteinloaded',
            function (e) {
                let $container = $('.js-em__carouselCustom');
                let index = 0;
                $container.find('.cc-emCarouselEditProd__item').each(function () {
                    if (removeNulls($(this))) {
                        index++;
                    }
                });
                if (index > 0) {
                    localStorage.setItem('suggestedProductsWithNullPrice', index);
                }
                setMinHeightPromoPanel('.recommended-products-pdp');
            }
        );
        $('body').on('listing:einsteinloadedSuggestedProducts', function (e) {
            let $container = $('.js-em__carouselCustom');
            let index = 0;
            $container.find('.cc-emCarouselEditProd__item').each(function () {
                if (removeNulls($(this))) {
                    index++;
                }
            });
            if (index > 0) {
                localStorage.setItem('suggestedProductsWithNullPrice', index);
            }
            setMinHeightPromoPanel('.recommended-products-pdp');
        });
        if ($('.suggested-products-slider.slick-initialized').length) {
            $('body').trigger('listing:einsteinloadedSuggestedProducts', {
                container: '.suggested-products-slider',
                type: 'suggested-products',
            });
        }
    }

    observeCurtainTap() {
        $('.overlay-pdp-mobile').on('click', function (e) {
            if ($(this).css('display') !== 'none' && !Foundation.MediaQuery.atLeast('medium')) {
                closeAllOpenMenus();
            }
        });
    }

    recentlyViewedItems() {
        $('body').on('click', '.recentlyviewed .js-pdp-link', (evt) => {
            if (Foundation.MediaQuery.is('medium')) {
                evt.preventDefault();
                const url = evt.currentTarget.dataset.quickview;
                openQuickView(url);

                // trigger for analytics product detail event
                const target = $(evt.currentTarget).closest('.product');
                if (target.length > 0) {
                    $('body').trigger('product:analyticsProductDetails', target);
                }
            }
        });
    }

    buyNowQuichview() {
        $('body').on('click', 'button.add-to-cart-quick-view', (e) => {
            e.preventDefault();
            openQuickView($(e.currentTarget).data('url'));
        });
    }

    suggedtedProductsPDP() {
        $('body').on('click', '.pdp-recommendations .js-pdp-link', (e) => {
            const $buyNowCta = $(e.currentTarget)
                .closest('.product')
                .find('.add-to-cart-quick-view');
            if ($buyNowCta.length) {
                e.preventDefault();
                e.stopPropagation();
                $buyNowCta.trigger('click');
            }
        });
    }

    getCrossSellItems() {
        $('body').on('product:afterAttributeSelect', (e, data) => {
            if (data.container.hasClass('product-quickview')) {
                return;
            }
            if (data.type === 'color' || data.type === 'size') {
                crossSellItems(data.data.product, data.type);
            }
        });
    }

    afterUpdateImages() {
        $('body').on('product:afterAttributeSelect', (e) => {
            computeCurrentlyVisibleImage(e);
        });
    }

    showSpinner() {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', () => {
            $.spinner().start();
        });
    }

    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    }

    updateAddToCart() {
        $('body').on('product:updateAddToCart', function (e, response) {
            if (
                $('.page').data('action') === 'Product-Show' &&
                !response.product.comingSoon &&
                !response.product.availability.orderable &&
                !response.product.availability.available
            ) {
                $('button.js-add-to-cart', '#fis-select-size').prop('disabled', true);
                $('button.js-add-to-cart', '#fis-select-size').data('disabled', true);
                return;
            }
            $('button.js-add-to-cart, button.add-to-cart-global').prop(
                'disabled',
                !response.product.available || response.product.comingSoon
            );
            $('button.js-add-to-cart, button.add-to-cart-global').data(
                'disabled',
                !response.product.readyToOrder
            );
        });
    }

    pdpCrossSell() {
        $('.js-shopTheLook-button').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let htmlContent = $('.pdp-buy-look-container').html();
            const modal = newModalFromString(htmlContent, false, [
                'cc-pdpCrossSell',
                'js-pdpCrossSell',
            ]);
            $(modal.modalBox).addClass(
                'rightModalAttribute cc-pdpCrossSell-modalBox rightModalAttribute_sizeLarge'
            );
            modal.open();
            initProductTile();

            $(modal.modalBox).on('click', '.js-pdpCrossSell-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
            $(modal.modalBox).on('click', '.color-variation', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });

            $('body').trigger('product:buyLookBtnAnalytics', true);
        });

        $('.pdp-buy-look-container').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $('.js-shopTheLook-button').removeClass('hidden');
            $('.embedded-service').removeClass('hide-for-STL');
            $('.img-wrapper .cell.hide-for-large > .icon-container').css('opacity', '1');
            $('.pdp-buy-look-container').addClass('hidden');
        });

        $('.pdp-buy-look-container').on('click', '.cross-sell-item', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openQuickView($(e.currentTarget).data('url'));
        });

        $('body').on('product:afterAttributeSelect', (e, d) => {
            if (d.type !== 'color' || d.container.hasClass('product-quickview')) {
                return;
            }
            $('.js-shopTheLook-button').addClass('hidden');
            $('.pdp-buy-look-container').addClass('hidden');
            var pdpCrossSell = d.data.product.pdpCrossSell;
            if (!pdpCrossSell) {
                return;
            }

            $('.cross-sell-item').addClass('hidden');
            pdpCrossSell.forEach((cs, i) => {
                const $csItem = $(`.cross-sell-item[data-index="${i}"]`);
                $csItem.attr('data-url', cs.url);
                $csItem.find('.js-prodTile').attr('data-pid', cs.idVariant);
                $csItem.find('.image-wrapper').attr('href', e.target.baseURI);
                $csItem.find('.cc-prodTile-imageContainer-image').attr('src', cs.image).attr('srcset', cs.image);
                $csItem.find('.cc-prodTile-body a').attr('href', e.target.baseURI);
                $csItem.find('.cc-prodTile-name').text(cs.name);
                $csItem.find('.js-prodTile-quickAdd-button').attr('data-url', cs.quickBuy);
                $csItem.removeClass('hidden');
            });
            $('.js-shopTheLook-button').removeClass('hidden');
        });
    }

    updateAvailability() {}

    handleAccordionsInPDP() {
        if ($('.js-intProductDetail-details').length > 0) {
            if (!Foundation.MediaQuery.atLeast('large')) {
                /* Shipping accordion */
                if ($('.js-details-accordion_shipping').length > 0) {
                    var $detailsAccordionShipping = $('.js-details-accordion_shipping');
                    $('.js-details-shipping-content', $detailsAccordionShipping)
                        .removeClass('accordion-content-visible')
                        .addClass('accordion-content');
                    $('.js-details-title', $detailsAccordionShipping).addClass('accordion-title');
                }
                /* Description accordion */
                if ($('.js-details-accordion_description').length > 0) {
                    var $detailsAccordionDescription = $('.js-details-accordion_description');
                    $('.js-details-description-content', $detailsAccordionDescription)
                        .removeClass('accordion-content-visible')
                        .addClass('accordion-content');
                    $('.js-details-title', $detailsAccordionDescription).addClass(
                        'accordion-title'
                    );
                }
            } else {
                $('.js-accordionDetails')
                    .removeClass('accordion-title')
                    .on('click', function (e) {
                        const htmlContent = $('.js-detailsPopup').html();
                        const modal = newModalFromString(htmlContent, false, ['cc-detailsPopup']);
                        $(modal.modalBox).addClass(
                            'rightModalAttribute cc-detailsPopup-modalBox rightModalAttribute_sizeMedium'
                        );

                        handleDetailsTabs($(e.currentTarget).data('tab'));

                        modal.open();

                        if ($('.pdp-size-box').hasClass('size-selected')) {
                            $('#main-and-care-label').addClass('hidden');
                        }

                        $('.js-detailsPopup-tabLink').on('click', function (e) {
                            handleDetailsTabs($(e.currentTarget).data('tab'));
                        });

                        $(modal.modalBox)
                            .find('.js-detailsPopup-close')
                            .on('click', function () {
                                $(modal.modalBox)
                                    .addClass('cc-modalClosing')
                                    .on(
                                        'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                                        function () {
                                            modal.close();
                                        }
                                    );
                            });
                    });
            }
        }
    }
}

const product = new Product();
export default product;
export {
    crossSellItems,
    computeCurrentlyVisibleImage,
    activatePromoAnimationMessage,
    closeAllOpenMenus,
    initializePrimaryImagesSlider,
    updatePrimaryImagesSlider,
    destroyPrimaryImagesSlider,
};
